/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const BYTES_IN_MB = 1024 * 1024;
export const BYTES_IN_GB = BYTES_IN_MB * 1024;

export const bytesToGb = (bytes: number): number => {
  return bytes / BYTES_IN_GB;
};

export const bytesToMb = (bytes: number): number => {
  return bytes / BYTES_IN_MB;
};

export const gigabytesToBytes = (gigabytes: number): number => {
  return gigabytes * BYTES_IN_GB;
};

export type Byte = number;
export type Megabyte = number;
export const megabytesToBytes = (megabytes: Megabyte): Byte => megabytes * BYTES_IN_MB;

export const formatBytes = (bytes: Byte): Megabyte => Math.round(bytesToMb(bytes));
